import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

const FALLBACK_LEVELS = ['Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7', 'Form I', 'Form II', 'Form III', 'Form IV', 'Form V', 'Form VI'];
const FALLBACK_SUBJECTS = ['Mathematics', 'Physics', 'Chemistry', 'Biology', 'English', 'History', 'Geography', 'Computer Science'];

let cachedData = null;

/**
 * Invalidate the module-level cache. Call this from admin pages whenever
 * categories (levels/subjects) are created/edited/deleted so other open
 * tabs (course/live-class creation forms) pick up the change on next render.
 */
export function invalidateCategoriesCache() {
  cachedData = null;
}

export function useCategories() {
  // Show cached data instantly (no flicker) but ALWAYS refetch on mount so
  // newly added admin levels/subjects surface in the very next form open.
  const [levels, setLevels] = useState(cachedData?.levels || FALLBACK_LEVELS);
  const [subjects, setSubjects] = useState(cachedData?.subjects || FALLBACK_SUBJECTS);
  const [levelGroups, setLevelGroups] = useState(cachedData?.levelGroups || []);
  const [loading, setLoading] = useState(!cachedData);

  useEffect(() => {
    axios.get(`${API}/categories`)
      .then(res => {
        const data = res.data;
        const newData = {
          levels: data.levels?.length ? data.levels : FALLBACK_LEVELS,
          subjects: data.subjects?.length ? data.subjects : FALLBACK_SUBJECTS,
          levelGroups: data.level_groups || [],
        };
        cachedData = newData;
        setLevels(newData.levels);
        setSubjects(newData.subjects);
        setLevelGroups(newData.levelGroups);
      })
      .catch(() => {
        // Silently fall back to defaults
      })
      .finally(() => setLoading(false));
  }, []);

  return { levels, subjects, levelGroups, loading };
}
